import React from 'react';

// Import CSS & Assets
import './Popup.css';
import popup_angle from '../../../assets/popup_angle.svg';


const Popup = ({ popupData, hidePopup, user }) => {
    return (
        <>
            {popupData?.type === "release" &&
                <div className={`popup__container ${popupData?.type === "release" ? "popup__container_release" : ""} ${popupData?.isVisible === false ? "popup__container_hidden" : ""}`}>
                    {popupData?.params?.title &&
                        <div className="popup__title">{popupData.params.title}</div>
                    }
                    {popupData?.params?.description &&
                        <div className="popup__text">{popupData.params.description}</div>
                    }
                    <div className="popup__bottom_part">
                        <div className="popup__bottom_btn" onClick={() => { hidePopup(popupData) }}>Ok, c'est noté</div>
                    </div>
                    {popupData?.type === "release" &&
                        <img className="popup__angle" src={popup_angle} />
                    }
                </div>
            }
            {popupData?.type === "modal" &&
                <>
                    {popupData?.id === "new_user" ?
                        <div className="popup__container_modal_main">
                            <div className={`popup__container_modal scale-up-center ${popupData?.isVisible === false ? "popup__container_hidden_modal" : ""}`}>
                                {popupData?.params?.title &&
                                    <div className="popup__title_modal"><span style={{fontSize: '19px'}}>👋</span> Bienvenue sur Proplab</div>
                                }
                                <div className="app__sectiondata_widget_spacer_10"></div>
                                {user?.result?.origin === "cardo_immo" &&
                                    <div className="popup__text_modal"><span>Vous avez été invité par <strong>Cardo Immobilier</strong>, et profitez ainsi d'un essai gratuit de notre logiciel.</span></div>
                                }
                                <div className="popup__text_modal">Découvrez votre Dashboard d'équipe, et commencez à créer votre première étude capacitaire.</div>
                                <div className="popup__text_modal_nb">Pour toute question, notre équipe est disponible à<br /><strong>hello@proplab.fr</strong></div>
                                <div className="popup__bottom_part">
                                    <div className="popup__bottom_btn_green" onClick={() => { hidePopup(popupData) }}>Démarrer la visite guidée</div>
                                </div>
                            </div>
                        </div>
                        :
                        <div className="popup__container_modal_main">
                            <div className={`popup__container_modal scale-up-center ${popupData?.isVisible === false ? "popup__container_hidden_modal" : ""}`}>
                                {popupData?.params?.title &&
                                    <div className="popup__title_modal">{popupData.params.title}</div>
                                }
                                <div className="app__sectiondata_widget_spacer_10"></div>
                                {popupData?.params?.description &&
                                    <div className="popup__text_modal">{popupData.params.description}</div>
                                }
                                <div className="popup__bottom_part">
                                    <div className="popup__bottom_btn" onClick={() => { hidePopup(popupData) }}>Démarrer la visite guidée</div>
                                </div>
                            </div>
                        </div>
                    }
                </>
            }
        </>
    );
};

export default Popup;